import { Component, ElementRef, HostListener, Output, EventEmitter, OnInit, Input, OnDestroy } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { SubscriptionLike } from 'rxjs';
import { idText } from 'typescript';

@Component({
  selector: 'app-custom-single-doc',
  templateUrl: './custom-single-doc.component.html',
  styleUrls: ['./custom-single-doc.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: CustomSingleDocComponent,
      multi: true
    }
  ]
})
export class CustomSingleDocComponent implements ControlValueAccessor, OnDestroy {
  subPost :SubscriptionLike;
  //export class CustomSingleDocComponent implements OnInit {

  onChange: Function;
  file: File | null = null;
  uploadedFileArray: FileInfo[] = [];
  value: any;
  @Input() dropdownContext: any;

  constructor(
    private host: ElementRef<HTMLInputElement>,
    private http: HttpClient
  ) { }
  ngOnDestroy(): void {
    if(this.subPost)
      this.subPost.unsubscribe();
  }

  saveTempFiles(event: any) {
    this.uploadedFileArray = [];
    var selectedFiles: File[] = event.target.files;
    const formData = new FormData();
    for (var i = 0; i < selectedFiles.length; i++) {
      formData.append(`files[${i}]`, selectedFiles[i]);
    }

    this.subPost = this.http.post('https://localhost:44391/api/FileStream/UploadFiles', formData, { withCredentials: true })
      .subscribe((res: any) => {
       // console.log('res');
       // console.log(res);
        alert('Uploaded Successfully.');
        res.forEach((obj: any) => {
          this.uploadedFileArray.push({
            FileID: obj.fileID,
            FileName: obj.fileName,
            FileExt: obj.fileExt
          })
        });
        this.value = this.uploadedFileArray;
      });
  }

  // set value(val: FileInfo[]) {
  //   this.uploadedFileArray = val
  //   //this.onChange(val);
  //   console.log(this.uploadedFileArray);
  // }

  writeValue(value: any) {
    // clear file input
    this.host.nativeElement.value = '';
    this.file = null;
  }

  registerOnChange(fn: Function): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: Function) {
  }

  setDisabledState(isDisabled: boolean): void {
  }


  save() {
    this.value = this.uploadedFileArray;
    this.dropdownContext.hide();
  }

  cancel() {
    this.dropdownContext.hide();
  }

}

export interface FileInfo {
  FileID: string;
  FileName: string;
  FileExt: string;
  IsChecked?: boolean;
}
